import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Book } from '../../../../data/book/data-types'
import { up } from 'styled-breakpoints'

type AffiliateBlockProps = {
  book: Book
}

const AffiliateBlock: React.FunctionComponent<AffiliateBlockProps> = ({ book }) => {
  const links = preprocessAffiliates(book.affiliate_links, book.isbn13)

  return (
    <Container>
      <Title>Buy on</Title>
      <Links count={Object.keys(links).length}>
          {
              Object.keys(links).map(key => (
                <Store href={links[key].url} target='blank'>
                    <Icon src={links[key].icon} />
                </Store>
              ))
          }
      </Links>
    </Container>
  )
}

const preprocessAffiliates = (links: { [key: string]: string }, isbn13: string): { [key: string]: { url: string, icon: string }} => {
  const supportedAffiliatesIcons: { [key: string]: string } = {
    "book24": require("./images/book24.png"),
    "amazon": require("./images/amazon.jpg"),
  }

  links = { ...(links || {}), amazon: `https://www.amazon.com/s?k=isbn%3A${isbn13}&tag=byzans-20` }

  return Object.keys(links)
    .filter(key => Object.keys(supportedAffiliatesIcons).includes(key))
    .map(key => [key, {
      url: links[key],
      icon: supportedAffiliatesIcons[key],
    }]).reduce((acc, [key, value]) => ({ ...acc, [key as string]: value}), {})
}

const Container = styled.div`
  display: grid;

  grid-gap: 10px;

  color: ${p => p.theme.colors.bg};
`

const Title = styled.div`
    text-align: center;
`

const Links = styled.div<{ count: number }>`
  display: grid;
  grid-template-columns: repeat(${p => Math.min(p.count, 3)}, 1fr);
  grid-gap: 16px;

  ${up('desktop')} {
    grid-template-columns: 1fr;
  }
`

const Store = styled.a``

const Icon = styled.img`
    width: 100px;

    border-radius: 10px;
`

export default AffiliateBlock